export default "__VITE_ASSET__c65a0611__"